import { createEffect, createMemo, createSignal } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListCollapsePropsType } from '~/types/ListCollapse'

export default function ListCollapse(props: ListCollapsePropsType) {
  const [isVisible, setIsVisible] = createSignal(props.in)
  const [height, setHeight] = createSignal<string>('0px')
  let containerRef: HTMLDivElement | undefined

  createEffect(() => {
    if (containerRef) {
      if (props.in) {
        setIsVisible(true)
        const scrollHeight = containerRef.scrollHeight
        setHeight(`${scrollHeight}px`)

        setTimeout(() => {
          if (props.in) {
            setHeight('auto')
          }
        }, props.timeout || 300)
      } else {
        const scrollHeight = containerRef.scrollHeight
        setHeight(`${scrollHeight}px`)

        requestAnimationFrame(() => {
          setHeight('0px')
        })

        setTimeout(() => {
          if (!props.in) {
            setIsVisible(false)
          }
        }, props.timeout || 300)
      }
    }
  })

  const collapseClasses = createMemo(() => twMerge('overflow-hidden transition-all duration-300 ease-in-out', !isVisible() && 'invisible', props.class))

  return (
    <div ref={containerRef} class={collapseClasses()} classList={props.classList} style={{ height: height() }}>
      <div class="ml-4 border-l border-border pl-4">{props.children}</div>
    </div>
  )
}
